function TumblerSelected() {
  return (
        <svg width="53" height="52" viewBox="0 0 53 52" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="26.25" cy="26" r="25.5" fill="#0D0F11" stroke="#0D0F11"/>
            <path
                d="M22.25 16.0001L22.2509 14.6654C22.2517 13.5613 23.1469 12.6667 24.2509 12.6667H28.2509C29.356 12.6667 30.2517 13.563 30.2509 14.6681L30.25 16.0001"
                stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M31.25 17.6667V26V35.5C31.25 36.0523 30.8023 36.5 30.25 36.5H22.25C21.6977 36.5 21.25 36.0523 21.25 35.5V23.5V17.6667C21.25 17.1145 21.6977 16.6667 22.25 16.6667H30.25C30.8023 16.6667 31.25 17.1145 31.25 17.6667Z"
                fill="#0D0F11" stroke="white" strokeWidth="2" strokeLinecap="round"/>
            <path d="M21.75 21H31.25" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        </svg>
  );
}

export default TumblerSelected;
